import { render, staticRenderFns } from "./VTSelect.vue?vue&type=template&id=1bb5e7cf&scoped=true&"
import script from "./VTSelect.vue?vue&type=script&lang=js&"
export * from "./VTSelect.vue?vue&type=script&lang=js&"
import style0 from "./VTSelect.vue?vue&type=style&index=0&id=1bb5e7cf&scoped=true&lang=css&"
import style1 from "./VTSelect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb5e7cf",
  null
  
)

export default component.exports